import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {
  ApiResponseModel,
  ApiVisa,
  BaseApiTemplateService,
  BasicApiResponseModel,
  Pagination,
  PagingResponseModel
} from '../../shared';
import {Core2Config} from '../../shared';
import {
  ClaimAccountEntitlementEmployeeLinkContainerModel, ClaimAccountTxnLineContainerModel
} from '../../../../../../models';
import {Observable} from 'rxjs';

export class AdjustBalanceRequestBody {
  employee_hdr_guid: string;
  entitlement_hdr_guid: string;
  current_claim_account_balance: number;
  new_claim_account_balance: number;
}

@Injectable({
  providedIn: 'root'
})
export class ClaimAccountEntitlementEmployeeLinkService extends BaseApiTemplateService<ClaimAccountEntitlementEmployeeLinkContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX + Core2Config.CLAIMS_PREFIX + 'entitlement-employee-links/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX + Core2Config.CLAIMS_PREFIX + 'entitlement-employee-links/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX + Core2Config.CLAIMS_PREFIX + 'entitlement-employee-links/backoffice-ep';
    this.httpClient = http;
  }

  adjustAccountBalance(body: AdjustBalanceRequestBody, apiVisa: ApiVisa): Observable<BasicApiResponseModel<ClaimAccountTxnLineContainerModel>> {
    let apiUrl = Core2Config.DOMAIN_URL + 'core2/tnt/dm/erp/aat/claims/account-txn-lines/processors/adjust-balances/backoffice-ep';
    if (apiVisa && apiVisa.api_domain_url) {
      apiUrl = apiVisa.api_domain_url + 'core2/tnt/dm/erp/aat/claims/account-txn-lines/processors/adjust-balances/backoffice-ep';
    }
    return this.httpClient.put<BasicApiResponseModel<ClaimAccountTxnLineContainerModel>>(apiUrl, body, this.getHttpHeader(apiVisa));
  }

  newEmployeeProration(body: ClaimAccountEntitlementEmployeeLinkContainerModel[], apiVisa: ApiVisa): Observable<BasicApiResponseModel<ClaimAccountEntitlementEmployeeLinkContainerModel[]>> {
    let apiUrl = Core2Config.DOMAIN_URL + 'core2/tnt/dm/erp/aat/claims/entitlement-employee-links/processors/new-employee-proration/backoffice-ep';
    if (apiVisa && apiVisa.api_domain_url) {
      apiUrl = apiVisa.api_domain_url + 'core2/tnt/dm/erp/aat/claims/entitlement-employee-links/processors/new-employee-proration/backoffice-ep';
    }
    return this.httpClient.post<BasicApiResponseModel<ClaimAccountEntitlementEmployeeLinkContainerModel[]>>(apiUrl, body, this.getHttpHeader(apiVisa));
  }

  topUpAccountTxn(body: ClaimAccountTxnLineContainerModel, apiVisa: ApiVisa): Observable<BasicApiResponseModel<ClaimAccountTxnLineContainerModel>> {
    let apiUrl = Core2Config.DOMAIN_URL + 'core2/tnt/dm/erp/aat/claims/account-txn-lines/processors/backoffice-ep';
    if (apiVisa && apiVisa.api_domain_url) {
      apiUrl = apiVisa.api_domain_url + 'core2/tnt/dm/erp/aat/claims/account-txn-lines/processors/backoffice-ep';
    }
    return this.httpClient.post<BasicApiResponseModel<ClaimAccountTxnLineContainerModel>>(apiUrl, body, this.getHttpHeader(apiVisa));
  }

  getUpAccountTxnByCriteria(pagination: Pagination, apiVisa: ApiVisa): Observable<PagingResponseModel<ClaimAccountTxnLineContainerModel>> {
    let apiUrl = Core2Config.DOMAIN_URL + 'core2/tnt/dm/erp/aat/claims/account-txn-lines/backoffice-ep';
    if (apiVisa && apiVisa.api_domain_url) {
      apiUrl = apiVisa.api_domain_url + 'core2/tnt/dm/erp/aat/claims/account-txn-lines/backoffice-ep';
    }
    const UrlByCriteria = apiUrl + '/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<ClaimAccountTxnLineContainerModel>>(UrlByCriteria, this.getHttpHeader(apiVisa));
  }

}


